
import {ChangeDetectorRef, Component, Input, OnChanges, OnInit, SimpleChanges, ViewChild} from '@angular/core';
import {TranslatePipe} from '@ngx-translate/core';
import {DamageIncidentComponent} from '../damage-incident/damage-incident.component';
import {SmokeIncidentComponent} from '../smoke-incident/smoke-incident.component';
import {FormsModule} from '@angular/forms';
import {Subject} from 'rxjs';
import {HarshDrivingComponent} from '../harsh-driving/harsh-driving.component';

@Component({
  selector: 'app-incident-overview',
  templateUrl: './incident-overview.component.html',
  standalone: true,
  styleUrl: './incident-overview.component.scss',
  imports: [
    SmokeIncidentComponent,
    DamageIncidentComponent,
    TranslatePipe,
    FormsModule,
    HarshDrivingComponent
],
})

export class IncidentOverviewComponent implements OnInit, OnChanges{
  @ViewChild(SmokeIncidentComponent) smokeIncidentComponent: SmokeIncidentComponent;
  @ViewChild(DamageIncidentComponent) damageIncidentComponent: DamageIncidentComponent;
  @ViewChild(HarshDrivingComponent) harshIncidentComponent: HarshDrivingComponent;
  @Input() reloadFlag: boolean = false;

  SMOKE_EVENT = 'com.bosch.ivs.SmokeEvent';
  DAMAGE_EVENT = 'com.bosch.ivs.damage.DamageEvent';
  HARSH_DRIVING_EVENT = 'com.bosch.ivs.drivingbehaviour.DrivingBehaviourEvent';
  toggleButtons = [
    { id: 1, name: this.SMOKE_EVENT },
    { id: 2, name: this.DAMAGE_EVENT },
    { id: 3, name: this.HARSH_DRIVING_EVENT },
  ];
  isSmokeIncident: boolean;
  isDamageIncident: boolean;
  isHarshDrivingIncident: boolean;
  licencePlate: string = '';
  private readonly licencePlateSubject = new Subject<string>();

  constructor(private readonly cdRef: ChangeDetectorRef) {}

  /* istanbul ignore next */
  ngOnChanges(change: SimpleChanges): void {
    this.ngOnInit();
  }

  /* istanbul ignore next */
  ngOnInit(): void {
    this.isSmokeIncident = true;
    this.isDamageIncident = false;
    this.licencePlateSubject.subscribe(() => {
      this.searchLicencePlateEvents();
    });
  }

  /* istanbul ignore next */
  filterEvents(event: string) {
    if (event === this.SMOKE_EVENT) {
      this.isDamageIncident = false;
      this.isHarshDrivingIncident = false;
      this.isSmokeIncident = true;
      this.cdRef.detectChanges();
      this.searchLicencePlateEvents();
    } else if( event === this.DAMAGE_EVENT) {
      this.isDamageIncident = true;
      this.isHarshDrivingIncident = false;
      this.isSmokeIncident = false;
      this.cdRef.detectChanges();
      this.searchLicencePlateEvents();
    } else if (event === this.HARSH_DRIVING_EVENT) {
      this.isHarshDrivingIncident = true;
      this.isDamageIncident = false;
      this.isSmokeIncident = false;
      this.cdRef.detectChanges();
      this.searchLicencePlateEvents();
    }
  }

  /* istanbul ignore next */
  searchLicencePlateEvents(): void {
    if (this.isSmokeIncident && this.smokeIncidentComponent) {
      this.smokeIncidentComponent.getIncidents(this.licencePlate);
    } else if (this.isDamageIncident && this.damageIncidentComponent) {
      this.damageIncidentComponent.getIncidents(this.licencePlate);
    } else if (this.isHarshDrivingIncident && this.harshIncidentComponent) {
      this.harshIncidentComponent.getIncidents(this.licencePlate);
    }
  }

  /* istanbul ignore next */
  onLicencePlateChange(value: string) {
    this.licencePlateSubject.next(value);
  }

  /* istanbul ignore next */
  scrollToTop(): void {
    const scrollableElements = this.getScrollableElements();

    // In embedded shells, the scroll owner is often a container rather than window.
    for (const element of scrollableElements) {
      element.scrollTo({ top: 0, behavior: 'smooth' });
    }

    window.scrollTo({ top: 0, behavior: 'smooth' });
    document.documentElement.scrollTop = 0;
    document.body.scrollTop = 0;
  }

  /* istanbul ignore next */
  onScrollToTopKeydown(event: KeyboardEvent): void {
    if (event.key === 'Enter' || event.key === ' ') {
      event.preventDefault();
      this.scrollToTop();
    }
  }

  private getScrollableElements(): HTMLElement[] {
    const allElements = Array.from(document.querySelectorAll<HTMLElement>('*'));
    return allElements.filter((element) => {
      const style = window.getComputedStyle(element);
      const overflowY = style.overflowY;
      const isScrollable = overflowY === 'auto' || overflowY === 'scroll';
      return isScrollable && element.scrollHeight > element.clientHeight;
    });
  }
}
